module.exports = __webpack_public_path__ + "img/_SDI9254-1000.efd5080a.webp";